import React, { useState } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const SupplierPaymentModal = ({ supplierId, supplierName, balance, onClose, onSuccess, companyId }) => {
   const isAdvance = balance >= 0;
  const [amount, setAmount] = useState(isAdvance ? 0 : Math.abs(balance)); 
  const [bank, setBank] = useState("HDFC Bank Account");
  const [ref, setRef] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    try {
      const payload = {
        companyId: companyId,
        supplierId: supplierId,
        amount: parseFloat(amount),
        bankAccountName: bank,
        paymentReference: ref || "MANUAL_PAY",
        paymentDate: new Date().toISOString()
      };
      await apiService.post(config.SETTLESUPPLIERPAYMENT, payload);
      
      onSuccess();
      onClose();
    } catch (error) {
      alert("Error recording payment");
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" style={modalStyles.overlay}>
      <div className="modal-content" style={modalStyles.content}>
        {/* <h4>{isAdvance ? "Add Top-up / Advance" : "Pay Supplier"}: {supplierName}</h4> */}
        <h4>{isAdvance ? "Add Top-up / Advance" : "Pay Supplier"}</h4>
       <div style={{
            padding: '10px', 
            borderRadius: '5px', 
            backgroundColor: isAdvance ? '#e6f4ea' : '#fdecea',
            marginBottom: '15px'
        }}>
            <small style={{ fontWeight: 'bold', color: '#666' }}>
                {isAdvance ? "CURRENT ADVANCE BALANCE" : "CURRENT OUTSTANDING DEBT"}
            </small>
            <h5 style={{ margin: 0, color: isAdvance ? '#1e7e34' : '#b02a37' }}>
                INR {Number(Math.abs(balance)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
            </h5>
        </div>
        <label className="small fw-bold">Amount Paid</label>
        <input type="number" className="form-control mb-2" value={amount} onChange={e => setAmount(e.target.value)} />
        
        <label className="small fw-bold">From Bank Account</label>
        <select className="form-control mb-2" value={bank} onChange={e => setBank(e.target.value)}>
            <option value="HDFC Bank Account">HDFC Bank Account</option>
            <option value="Main Bank Account">Main Bank Account</option>
        </select>

        <label className="small fw-bold">Reference (UTR / Cheque No)</label>
        <input type="text" className="form-control mb-3" placeholder="e.g. UTR12345" value={ref} onChange={e => setRef(e.target.value)} />

        <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-success" onClick={handlePay} disabled={loading}>
                {loading ? "Processing..." : "Confirm Payment"}
            </button>
        </div>
      </div>
    </div>
  );
};

const modalStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 },
    content: { background: 'white', padding: '30px', borderRadius: '8px', width: '400px', color: '#333' }
};

export default SupplierPaymentModal;